import { initYandexMetrika } from '@/shared/lib/metrika';

export default defineNuxtPlugin({
  name: 'metrika',
  setup: (nuxtApp) => {
    nuxtApp.hook('app:suspense:resolve', () => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(() => initYandexMetrika());
        return;
      }
      setTimeout(initYandexMetrika);
    });
  },
});
